import React from "react";

import "./WaveAnimation.css";

const WaveAnimation = ({ width = "100%", height = "auto", className = "" }) => {
	return (
		<svg
			width="1084"
			height="200"
			viewBox="0 0 1084 200"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={`wave-svg ${className}`}
			style={{ width, height }}>
			<defs>
				<linearGradient
					id="paint0_linear_1705_4525"
					x1="768.774"
					y1="231.688"
					x2="769.747"
					y2="96.472"
					gradientUnits="userSpaceOnUse">
					<stop stopColor="#184168" />
					<stop offset="0.35" stopColor="#0D6E72" />
					<stop offset="0.73" stopColor="#03987D" />
					<stop offset="0.93" stopColor="#00A981" />
				</linearGradient>

				<mask id="reveal-mask">
					<rect className="reveal-rect" x="0" y="0" width="1084" height="200" fill="white" />
				</mask>
			</defs>

			<mask
				id="mask0_1705_4525"
				style={{ maskType: "luminance" }}
				maskUnits="userSpaceOnUse"
				x="0"
				y="0"
				width="1085"
				height="200">
				<path d="M1084.21 0H0V199.975H1084.21V0Z" fill="white" />
			</mask>

			<g mask="url(#mask0_1705_4525)">
				<g mask="url(#reveal-mask)">
					<path
						className="wave-line"
						d="M1092.82 96.8518C1092.82 96.8518 951.923 29.559 637.65 121.616C300.577 220.358 60.5554 228.971 60.5554 228.971"
						stroke="#33A980"
						strokeWidth="1.85"
						strokeMiterlimit="10"
					/>
					<path
						className="wave-line"
						d="M25.5583 197.459C25.5583 197.459 269.199 74.5921 598.667 113.541C928.134 152.489 1167.92 132.257 1167.92 132.257"
						stroke="#33A980"
						strokeWidth="0.97"
						strokeMiterlimit="10"
					/>
				</g>

				<path
					className="wave-shape wave-shape-secondary"
					d="M60.0293 300.483L38.17 225.34C33.9927 211.005 140.866 175.262 152.473 171.381C272.229 131.343 408.534 119.737 540.806 122.667C661.215 125.334 989.152 158.711 1105.97 135.625C1868.04 -15.011 1172.64 142.31 1255.02 109.121C1333.54 77.4838 1343.72 48.4383 1443.11 42.6543L1447.11 116.958L60.0293 300.483Z"
					fill="#194168"
				/>
			</g>

			<mask
				id="mask1_1705_4525"
				style={{ maskType: "luminance" }}
				maskUnits="userSpaceOnUse"
				x="-109"
				y="-45"
				width="1195"
				height="245">
				<path d="M1085.45 -44.9702H-108.356V199.976H1085.45V-44.9702Z" fill="white" />
			</mask>
			<g mask="url(#mask1_1705_4525)">
				<path
					className="wave-shape"
					fillRule="evenodd"
					clipRule="evenodd"
					d="M1390.72 530.03L210.461 415.814C210.461 415.814 481.032 300.809 91.7261 252.646C167.109 261.973 189.909 228.27 269.853 222.586C464.211 208.752 672.408 109.397 861.281 89.1148C1138.13 59.4058 1230.43 200.99 1444.88 288.877C1426.08 380.321 1390.72 530.03 1390.72 530.03Z"
					fill="url(#paint0_linear_1705_4525)"
				/>
			</g>
		</svg>
	);
};

export default WaveAnimation;
